// QuotationList.tsx
import React from 'react';
import { QuoteData } from '../../types/Interface';
import ZoomableImage from './ZoomableImage';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";


interface QuotationListProps {
  quotations: QuoteData[];
  onSelectQuotation: (data: QuoteData) => void;
}

const QuotationList: React.FC<QuotationListProps> = ({ quotations, onSelectQuotation }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
      {quotations.map((q) => (
        <div key={q.id} className="border p-4 shadow-md rounded-xl">
        {q.images && q.images.length > 0 && (
        <Carousel
            showThumbs={false}
            showIndicators={true}
            showStatus={false}
            infiniteLoop
            className="rounded-md"
        >
            {q.images.map((image, index) => (
            <div key={index} className="h-100 w-full flex justify-center items-center bg-gray-100">
                <ZoomableImage
                src={image}
                alt={`Product image ${index + 1}`}
                />
            </div>
            ))}
        </Carousel>
        )}
          
        {q.link != "" && 
        <div>
          <a
            className="text-blue-700 underline"
            href={q.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Product Link
          </a><br />
        </div>
            
        }
          {/* <h3 className="text-lg font-semibold">{q.productName}</h3> */}
          
          <button
            onClick={() => onSelectQuotation(q)}
            className="mt-2 bg-blue-600 text-white px-4 py-1 rounded"
          >
            Quote Now
          </button>
        </div>
      ))}
    </div>
  );
};

export default QuotationList;
